import { defineMessages } from 'react-intl';

const messages = defineMessages({
  assetModalTitle: {
    id: 'ProductListing.AssetModalTitle',
    defaultMessage: 'Assets',
  },
  closeButton: {
    id: 'ProductListing.CloseButton',
    defaultMessage: 'Close',
  },
});

export default messages;
